import React from 'react';
import PropTypes from 'prop-types';
import LoadingIcon from 'components/icon/Loading';

import 'sass/ui-kit/loading.scss';

function Loading({centered = false, children}) {
    return (
        <div className={'loader' + (centered ? ' centered' : '')}>
            <LoadingIcon colorIndex="theme"/>
            {children}
        </div>
    )
}

Loading.propTypes = {
    centered: PropTypes.bool
};

export default Loading;


// WEBPACK FOOTER //
// ./src/components/Loading.js